var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_CATEGORY_EQUIPMENTS))?_c('object-link',{attrs:{"object":_vm.categoryEquipment}}):_c('span',[_vm._v(_vm._s(_vm.$objectDenomination(_vm.categoryEquipment)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }